import { CurrencyEnum } from '../../../enums';
import { FxOrder, FxOrderSideType, FxOrderStatus, FxOrderType } from '../../../models/reporting/types';

export const getFxOrderDateByStatus = (
  item: FxOrder,
): string => (item.orderStatus === FxOrderStatus.Fill ? item.fillDate : item.lastUpdatedDate);

export const isSellEUR = (
  fxOrder: FxOrder,
): boolean => fxOrder.side === FxOrderSideType.Sell && fxOrder.soldAmountCurr === CurrencyEnum.EUR;

export const isBuyEUR = (
  fxOrder: FxOrder,
): boolean => fxOrder.side === FxOrderSideType.Buy && fxOrder.boughtAmountCurr === CurrencyEnum.EUR;

export const isSellOrBuyEUR = (fxOrder: FxOrder): boolean => isBuyEUR(fxOrder) || isSellEUR(fxOrder);
